import React from 'react';
import {useIntl} from 'react-intl';
import searchIcon from '../images/search.svg';
import '../styles/CustomInput.css';

const CustomInput = ({onChange, value}) => {
  const {formatMessage} = useIntl();

  return (
    <div className="input-container">
      <img src={searchIcon} alt="search icon" className="input-icon" />
      <input
        type="text"
        placeholder={formatMessage({
          id: 'new-searchbar-placeholder-text',
          defaultMessage: 'Search here'
        })}
        className="input-field"
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default CustomInput;
